var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMintitIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 68,
    viewBox: "0 0 69 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.417 39.6666C10.417 35.7546 13.5883 32.5833 17.5003 32.5833H51.5003C55.4123 32.5833 58.5836 35.7546 58.5836 39.6666V56.6666C58.5836 57.449 57.9494 58.0833 57.167 58.0833C56.3846 58.0833 55.7503 57.449 55.7503 56.6666V39.6666C55.7503 37.3194 53.8475 35.4166 51.5003 35.4166H17.5003C15.1531 35.4166 13.2503 37.3194 13.2503 39.6666V56.6666C13.2503 57.449 12.6161 58.0833 11.8337 58.0833C11.0513 58.0833 10.417 57.449 10.417 56.6666V39.6666Z",
    fill: "#33CCBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 19.8333C17.5 15.1388 21.3056 11.3333 26 11.3333H43C47.6944 11.3333 51.5 15.1388 51.5 19.8333V36.8332C51.5 41.5277 47.6944 45.3332 43 45.3332H26C21.3056 45.3332 17.5 41.5277 17.5 36.8332V19.8333Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43 14.1666H26C22.8704 14.1666 20.3333 16.7036 20.3333 19.8333V36.8332C20.3333 39.9629 22.8704 42.4999 26 42.4999H43C46.1296 42.4999 48.6667 39.9629 48.6667 36.8332V19.8333C48.6667 16.7036 46.1296 14.1666 43 14.1666ZM26 11.3333C21.3056 11.3333 17.5 15.1388 17.5 19.8333V36.8332C17.5 41.5277 21.3056 45.3332 26 45.3332H43C47.6944 45.3332 51.5 41.5277 51.5 36.8332V19.8333C51.5 15.1388 47.6944 11.3333 43 11.3333H26Z",
    fill: "#33CCBD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.667 27.625C31.667 28.7986 30.7156 29.75 29.542 29.75C28.3684 29.75 27.417 28.7986 27.417 27.625C27.417 26.4514 28.3684 25.5 29.542 25.5C30.7156 25.5 31.667 26.4514 31.667 27.625Z",
    fill: "#33CCBD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.583 27.625C41.583 28.7986 40.6316 29.75 39.458 29.75C38.2844 29.75 37.333 28.7986 37.333 27.625C37.333 26.4514 38.2844 25.5 39.458 25.5C40.6316 25.5 41.583 26.4514 41.583 27.625Z",
    fill: "#33CCBD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMintitIcon);
export default __webpack_public_path__ + "static/media/MintitIcon.9f6e33b2ed8275fbb6da24def22a8b41.svg";
export { ForwardRef as ReactComponent };